import { subscribeKey as subKey } from 'valtio/vanilla/utils';
import { proxy } from 'valtio/vanilla';
import { CoreHelperUtil } from '../utils/CoreHelperUtil.js';
// -- State --------------------------------------------- //
const state = proxy({
    message: '',
    variant: 'success',
    svg: undefined,
    open: false
});
// -- Controller ---------------------------------------- //
export const SnackController = {
    state,
    subscribeKey(key, callback) {
        return subKey(state, key, callback);
    },
    showLoading(message) {
        this._showMessage({ message, variant: 'loading' });
    },
    showSuccess(message) {
        this._showMessage({ message, variant: 'success' });
    },
    showSvg(message, svg) {
        this._showMessage({ message, svg });
    },
    showError(message) {
        const errorMessage = CoreHelperUtil.parseError(message);
        this._showMessage({ message: errorMessage, variant: 'error' });
    },
    hide() {
        state.open = false;
    },
    _showMessage({ message, svg, variant = 'success' }) {
        if (state.open) {
            state.open = false;
            setTimeout(() => {
                state.message = message;
                state.variant = variant;
                state.svg = svg;
                state.open = true;
            }, 150);
        }
        else {
            state.message = message;
            state.variant = variant;
            state.svg = svg;
            state.open = true;
        }
    }
};
